import styled from 'styled-components';

export const PageHeader = styled.div`
  position: relative;
  margin-bottom: 36px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 42px;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-top: -10px;
  }
`;

export const Title = styled.h1`
  font-size: 18px;
  line-height: 21px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Grid = styled.div`
  display: flex;
  margin: 0 -19px;
  flex-wrap: wrap;
`;

export const SevenColumns = styled.div`
  padding: 0 19px;
  width: 100%;
  max-width: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 58.333333333333336%;
  }
`;

export const FourColumns = styled.div`
  padding: 0 19px;
  width: 100%;
  max-width: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 41.6666%;
  }
`;
